// import { Loader } from "@googlemaps/js-api-loader"; 
// import haversine from 'haversine-distance'
import { fadeInOnScroll } from '../functions/fade-in-on-scroll';


export const locationsList = (allStoresClicked = false) => {

    let urlParams = new URLSearchParams(window.location.search);
    let urlAddressValue = urlParams.get('address');
    let locationList = document.querySelector('#location-list');

    if(allStoresClicked) {
        urlAddressValue = null;
    }

    if(!urlAddressValue && locationList) {

        const getLocationsByRegion = () => {
            const formData = new FormData();
            formData.append('action', 'ajax_locations_by_region');
                
            const ajaxData = new URLSearchParams(formData);

            return ajaxData;
        }

        const data = getLocationsByRegion();

        document.querySelector('.locations__list-loader').style.display = 'flex';
        
        const container = document.querySelector('.js-location-container');
        const regionContainer = document.querySelector('.locations__list-region-container');
        const regionSearchBar = document.querySelector('.locations__search-bar--regions');
        const postcodeSearchBar = document.querySelector('.locations__search-bar--postcode');
        
        container.style.display = 'none';
        postcodeSearchBar.style.display = 'none';
        regionSearchBar.style.display = 'flex';


        fetch(igniteAjax.ajaxurl, {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Cache-Control': 'no-cache',
            },
            body: data
        })
        .then((response) => response.json())
        .then((data) => {
            regionContainer.style.display = 'block';
            regionContainer.innerHTML = data.html;
            fadeInOnScroll();
            locationModals();
            toggleRegions();
            document.querySelector('.locations__list-loader').style.display = 'none';
        })
        .catch((error) => {
            console.error(error);
        });
    }
}

const allStoresButton = document.getElementById('all-stores');
if (allStoresButton) {
    allStoresButton.addEventListener('click', () => locationsList(true));
}

export const toggleRegions = () => {

    const toggleButtons = document.querySelectorAll('.js-open-location-region');

    toggleButtons.forEach(function(button) {
        button.addEventListener('click', function () {
            
            const regionId = this.getAttribute('data-id');

            this.classList.toggle('active');
            const ul = document.querySelector(`ul[data-id="${regionId}"]`);

           if (ul.classList.contains('open')) {
                ul.classList.remove('open');
            } else {
                ul.classList.add('open');
            }
        });
    });
}

export const locationModals = () => {

    const locationModalTriggers = document.querySelectorAll('.js-open-location-modal');
            
    locationModalTriggers.forEach(locationModalTrigger => {
        locationModalTrigger.addEventListener('click', (e) => {
            e.preventDefault();
            
            const locationID = e.currentTarget.getAttribute('data-location-id');
            const container = document.querySelector('.location-modal__content');

            const getFetchData = () => {
                const formData = new FormData();
                formData.append('locationID', locationID);
                formData.append('action', 'ajax_get_location_modal');
                    
                const ajaxData = new URLSearchParams(formData);

                return ajaxData;
            }

            const data = getFetchData();

            fetch(igniteAjax.ajaxurl, {
                method: 'POST',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'Cache-Control': 'no-cache',
                },
                body: data
            })
            .then((response) => response.text())
            .then((data) => {
                container.innerHTML = data;

                document.querySelector('.location-modal').classList.add('active');
                document.body.classList.add('js__popup-active');
            })
            .catch((error) => {
                console.error(error);
            });  
        });
    });

    const locationModalCloseTriggers = document.querySelectorAll('.js-close-location-modal');
    
    locationModalCloseTriggers.forEach(locationModalCloseTrigger => {
        locationModalCloseTrigger.addEventListener('click', function() {
            document.querySelector('.location-modal').classList.remove('active');
            document.body.classList.remove('js__popup-active');
        });
    });
}

function comparator(a, b) {
	 if (a.dataset.subject < b.dataset.subject)
                return -1;
            if (a.dataset.subject > b.dataset.subject)
                return 1;
            return 0;
}

